module.exports = __webpack_public_path__ + "static/media/gptKnowledge.66e5a8c0.mp4";